.header {
    display: flex;
    justify-content: space-between;
    padding: 10px 15px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    overflow: hidden;
    text-overflow: ellipsis;

    & > div {
        text-align: left;
        font-weight: bold;
    }
}
